import React from "react";

export default function KeyIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M276-360q50 0 85-35t35-85q0-50-35-85t-85-35q-50 0-85 35t-35 85q0 50 35 85t85 35Zm0 124q-100 0-172-72T32-480q0-100 72-172t172-72q80 0 137.5 44T497-570h315l91 90-112 150-123-83-91 91-66-68h-14q-23 68-82.5 111T276-236Z"/></svg>
    );
}
